module.exports = __webpack_public_path__ + "img/icon-play.c9a74cd5.svg";